import { Component } from '@angular/core';
import { EnvService } from '../core/services';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { notCcsmedEmail } from '../core/utils/validators';
import { asFormControl } from '../core/utils/common';
import { Store } from '@ngxs/store';
import { createUserFromEmail } from '../core/store/user/user.actions';

@Component({
  selector: 'app-registration',
  templateUrl: './registration.component.html',
  styleUrls: ['./registration.component.scss'],
})
export class RegistrationComponent {
  helpPhone = this.envService.ccs.helpPhone;
  isSent = false;
  disableButton: boolean = false;
  errorMessage = '';
  successMessage = '';

  signUpForm = new FormGroup({
    email: new FormControl('', [Validators.required, Validators.email, notCcsmedEmail()]),
  });

  asFormControl = asFormControl;

  constructor(private envService: EnvService, private store: Store) {}

  sendActivation() {
    if (this.signUpForm.invalid) {
      this.signUpForm.markAllAsTouched();
      return;
    }

    this.disableButton = true;
    this.errorMessage = '';
    this.successMessage = '';

    this.store.dispatch(new createUserFromEmail(this.signUpForm.value.email)).subscribe({
      error: (err) => {
        this.disableButton = false;
        this.errorMessage = 'Unable to send email. Please try again.';
      },
    });

    // optimistically return success early
    setTimeout(() => {
      this.disableButton = false;
      if (this.isSent) {
        this.successMessage = 'Email has been sent. Please check your inbox.';
      }
      this.isSent = true;
    }, 3000);
  }
}
